import { Injectable } from '@angular/core';
import { RequireAdapterService } from './require-adapter.service';

@Injectable()
export class BackboneAdapterService {
    private bbView: any;

    constructor(private requireAdapterService: RequireAdapterService) {
        const BackboneView = requireAdapterService.loadBackboneView();
        this.bbView = new BackboneView();
    }

    addListener(eventName: string, listener: any): void {
        this.bbView.registerListener(eventName, listener);
    }

    addListenerOnce(eventName: string, listener: any): void {
        this.bbView.registerListenerOnce(eventName, listener);
    }

    triggerEvent(eventName: string, ...params): void {
        this.bbView.triggerEvent(eventName, params);
    }
}



// WEBPACK FOOTER //
// ./ts/app/shared/backbone-adapter.service.ts